import { styled as muiStyled, Grid, Button, Stack } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const Line = muiStyled(Grid)<{ hasError?: boolean }>(({ hasError }) => ({
  background: `${
    hasError
      ? `linear-gradient(0deg, rgba(201, 54, 0, 0.04), rgba(201, 54, 0, 0.04)), ${NEW_COLORS.BASE.WHITE}`
      : NEW_COLORS.BASE.WHITE
  }`,
  padding: '16px',
  borderRadius: '4px',
  border: `1px solid ${
    hasError ? NEW_COLORS.SEMANTICS.ERROR[700] : NEW_COLORS.GRAYSCALE[200]
  }`,
}));

const StyledGrid = muiStyled(Grid)({
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'column',
});

const ActionButton = muiStyled(Button)(() => ({
  borderRadius: '4px',
  height: '53px',
  fontWeight: 600,
  '& .MuiButton-endIcon': {
    marginLeft: 0,
  },
}));

const ErrorBox = muiStyled(Stack)(() => ({
  background: `#EFD1D1`,
  paddingTop: '16px',
  width: '100%',
}));

const ReprocessButton = muiStyled(Button)({
  padding: '16px 16px',
  borderRadius: '4px',
  fontWeight: 600,
  margin: '16px',
  height: '52px',
});

export { ActionButton, StyledGrid, Line, ErrorBox, ReprocessButton };
